export const CHANGE_EMPLOYEE = 'CHANGE_EMPLOYEE';
export const CHANGE_COSTSAVING = 'CHANGE_COSTSAVING';
export const CHANGE_REPLACEMENTDATA = 'CHANGE_REPLACEMENTDATA';